
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/saisonende-skigebiet",
      function () {
        return require("private-next-pages/[region]/saisonende-skigebiet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/saisonende-skigebiet"])
      });
    }
  